import { createFileRoute } from '@tanstack/react-router';
import { AdminShell, evaluateAdminAccess, requireAdminAccess } from '../../../features/admin';

export const Route = createFileRoute('/_auth/admin')({
  beforeLoad: requireAdminAccess(evaluateAdminAccess),
  component: AdminShell,
});
